import React from 'react'
import { useTranslation } from 'react-i18next'
import { Checkbox, FormControlLabel, Link } from '@mui/material'
import { getUrlForLanguage } from './utils'

const MiscellaneousCheckbox = ({ value, onClick }) => {
  const { t, i18n } = useTranslation()
  // Get the current language code
  const languageCode = i18n.language

  const url = getUrlForLanguage(languageCode)

  return (
    <FormControlLabel
      control={<Checkbox checked={value} onChange={onClick} color="primary" />}
      label={
        <span>
          {t('showMiscellaneousPictos')} (
          <Link
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            underline="always"
          >
            {t('moreInfo')}
          </Link>
          )
        </span>
      }
    />
  )
}

export default MiscellaneousCheckbox
